
<!-- 
CreditCardDetailModal.vue
功能：信用卡身分驗證異常名單-明細查詢
作者：i9400538 陳博承
完成：2022-04-26
-->
<template>
  <div id="credit-card-detail-modal" class="modal fade" :class="{ 'is-open': open }">
    <div class="modal-dialog">
      <div class="modal-content">
        <div class="modal-header">
          <a class="close" @click="$emit('close')">
            <i class="icon-close"></i>
          </a>
        </div>
        <div class="modal-body">
          <template>
            <div class="row">
              <table class="table datatable table-striped area-list-datatable">
                <thead>
                  <tr>
                    <th id="th_insd_name" class="text-center">被保人</th>
                    <th
                      id="th_policy_no"
                      class="text-center"
                      :class="'sorting ' + (order.fieldName == 'policy_no' ? (order.asc ? 'sorting_asc' : 'sorting_desc') : '')"
                      @click="columnSorting('policy_no')"
                    >保單號碼</th>
                    <th id="th_prod_name" class="text-center">商品名稱</th>
                    <th id="th_eft_name" class="text-center">契約效力</th>
                  </tr>
                </thead>
                <tbody>
                  <tr
                    v-for="(item, i) in tableDataBackup"
                    :key="`table-item-credit-card-detail-${i}`"
                  >
                    <td class="text-center">
                      <Tooltip
                        :position="'top'"
                        expand_col1="被保人"
                        :expand_col1_value="item.insd_name"
                      >{{item.insd_name | getMaskName}}</Tooltip>
                    </td>
                    <td class="text-center">{{item.policy_no}}</td>
                    <td class="text-center">{{item.prod_name}}</td>
                    <td class="text-center">{{item.eft_name}}</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </template>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { commonMixin } from "@/mixins/common";
import Tooltip from "@/desktop/components/ToolTip";
export default {
  name: "CreditCardDetailModal",
  mixins: [commonMixin],
  components: { Tooltip },
  props: {
    open: {
      type: Boolean,
      default: false
    },
    tableData: {
      type: Array,
      default: () => {
        return [];
      }
    }
  },
  watch: {
    open: function() {
      this.init();
    }
  },
  data() {
    return {
      order: {
        fieldName: "policy_no",
        asc: true
      },
      tableDataBackup: []
    };
  },
  methods: {
    //初始化
    init() {
      this.order.asc = true;
      this.tableDataBackup = this.tableData;
      this.registerHanlink(); // for hard word
    },
    columnSorting(fieldName) {
      //切換表頭圖案
      this.order.asc = !this.order.asc;
      //data排序
      let sortOrder = -1;
      if (this.order.asc) {
        sortOrder = 1;
      }
      this.tableDataBackup = [];
      setTimeout(() => {
        this.tableDataBackup = [...this.tableData];
        this.tableDataBackup.sort(this.sortCompareFun(sortOrder, fieldName));
        this.registerHanlink(); // for 難字更新
      }, 20);
    },
    sortCompareFun(sortOrder, property) {
      return function(a, b) {
        let result =
          a[property] < b[property] ? -1 : a[property] > b[property] ? 1 : 0;
        return result * sortOrder;
      };
    }
  }
};
</script>

<style lang="scss" scoped>
.text-center {
  text-align: center;
}
.table.datatable {
  tbody {
    tr > td {
      &:first-child {
        padding-top: 10px;
      }
    }
  }
}
</style>